import Enumerator from '../global/Enumerator';

export const fieldTypes = [
  'text_short',
  'text_large',
  'options_multiple',
  'options_single',
  'number',
  'money',
  'phone'
];

export class FieldType extends Enumerator {
  static default() {
    return this.of('text_short');
  }
}
FieldType.initEnum(fieldTypes);

export const fieldEntities = ['ticket', 'contact'];

export class FieldEntity extends Enumerator {
  static default() {
    return this.of('ticket');
  }
}
FieldEntity.initEnum(fieldEntities);

export default {
  fieldTypes,
  FieldType,
  fieldEntities,
  FieldEntity
};
